module.exports = __webpack_public_path__ + "static/media/ser_saf_tip_are.367fdfe6.png";